import { getBearerToken } from '@/features/auth/auth.utils.js'
import { isInIframe } from '@/features/embed/isInIframe.js'
import { postMessageEvents, sendParentPostMessage } from '@/features/embed/postMessage.js'

function goToUrl(url) {
  window.location.href = url
}

function getCurrentUrl() {
  return `${window.location.pathname}${window.location.search}`
}

export function unauthorizedHandler(error) {
  console.log('[unauthorizedHandler] Checking error:', {
    status: error?.response?.status,
    message: error?.message,
    code: error?.code,
  })

  if (error?.response?.status === 401) {
    console.log('[unauthorizedHandler] 401 detected, handling...')
    if (isInIframe()) {
      doParentLogout()
      return
    }

    const token = getBearerToken()
    const redirectUrl = encodeURIComponent(getCurrentUrl())

    if (token) {
      console.log('[unauthorizedHandler] Token found, redirecting to /auth/logout')
      goToUrl(`/auth/logout?redirectUrl=${redirectUrl}`)
      return true
    }

    const isAlreadyOnLogin = window.location.pathname.includes('/auth/login')
    if (!isAlreadyOnLogin) {
      console.log('[unauthorizedHandler] No token, redirecting to /auth/login')
      goToUrl(`/auth/login?redirectUrl=${redirectUrl}`)
    }

    return true
  }

  console.log('[unauthorizedHandler] Not 401, re-throwing error')
  throw error
}

export function unauthorizedResponseInterceptor(client) {
  client.interceptors.response.use(request => request, unauthorizedHandler)
}

export function doParentLogout() {
  console.log('[unauthorizedHandler] Sending post message FM_doLogout, parent should logout')
  sendParentPostMessage({ type: postMessageEvents.FM_doLogout })
}
